module.exports = __webpack_public_path__ + "bf2a254870f14eb4e875275a5f42582e.pdf";